import { createSlice } from "@reduxjs/toolkit";

import { formatToUSD, normalizeProductData } from "@/app/utils/utility";

const initialState = {
  cartDetails: {
    items: [],
    subTotal: "$0.00",
    isCartSynced: false,
  },
  cartInputValue:[]
};

/**
 * Calculates the total price of a given list of products
 * @function calculateSubtotal
 * @param {Object[]} productList - List of products to calculate subtotal
 * @returns {string} Formatted subtotal price as a string
 */
const calculateSubtotal = (productList = []) => {
  if (!productList.length) return "$0.00";
  return formatToUSD(
    productList.reduce(
      (total, product) =>
        total +
        (product?.isFlash == null
          ? product?.discountedPrice?.rawValue                   
          : product?.isFlash) *
          product?.quantity,
      0
    )
  );
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    /**
     * Adds a new product to the cart or updates the quantity of an existing product in the cart
     * @function addStoreCartItem
     * @param {Object} actions.payload - Details of the product to be added
     * @param {Object} actions.payload.newProduct - Details of the new product
     * @param {string} actions.payload.newProduct.id - Unique identifier of the product
     * @param {string} actions.payload.newProduct.name - Name of the product
     * @param {number} actions.payload.quantity - Quantity of the product to be added
     * @returns {void}
     */
    addStoreCartItem: function (state, actions) {
      const { newProduct, quantity, inputQuantity, localCartItems } =
        actions.payload;
      // Normalize product data if not already normalized
      const newCartItem = newProduct?.isNormalized
        ? { ...newProduct }
        : normalizeProductData(newProduct);

      // Find the product in the cart
      const productIndex = state.cartDetails?.items?.findIndex(
        (product) => product.id === newCartItem.id
      );
      console.log(productIndex,inputQuantity,'checks')
      if (productIndex === -1) {
        // If the product is not already in the cart, add it as a new item
        state.cartDetails.items.push({ ...newCartItem, quantity });
      } else {
        // If the product already exists, increment its quantity

        console.log(localCartItems,inputQuantity,"localCartItems")
        if (
          localCartItems?.length > 0 &&
          inputQuantity != 1 &&
          localCartItems[productIndex]?.stockLeft >= inputQuantity
        ) {
          //if qty increased by inputing value
          state.cartDetails.items[productIndex].quantity = inputQuantity;
        } else if (
          localCartItems?.length > 0 &&
          localCartItems[productIndex]?.stockLeft >
          state.cartDetails.items[productIndex].quantity
        ) {
          //if qty increased by pressing + - or add to cart button
          state.cartDetails.items[productIndex].quantity = 0;
          state.cartDetails.items[productIndex].quantity = inputQuantity;
        }
      }

      // Recalculate the subtotal
      state.cartDetails.subTotal = calculateSubtotal(state.cartDetails.items);
    },

    /**
     * Updates the quantity of a product in the cart or removes it if quantity is zero.
     * @function updateStoreCartItem
     * @param {Object} actions.payload - Payload containing product details
     * @param {string} actions.payload.productId - Unique identifier of the product to be updated
     * @param {number} actions.payload.quantity - New quantity of the product; if zero, product is removed
     * @returns {void}
     */
    updateStoreCartItem: function (state, actions) {
      const { productId, quantity } = actions.payload;
      if (!quantity) {
        const updatedCartItems = state.cartDetails.items.filter(
          (product) => product.id !== productId
        );
        if(updatedCartItems.length){
          state.cartDetails.items = [...updatedCartItems];
        }else{
          state.cartDetails.items = []
        }
      } else {
        const productToUpdate = state.cartDetails.items.find(
          (product) => product.id === productId
        );
        productToUpdate.quantity = quantity;
      }
      state.cartDetails.subTotal = calculateSubtotal(state.cartDetails.items);
    },
    /**
     * Replaces the current cart items with a new set of items and updates the subtotal.
     * @function setStoreCartItems
     * @param {Object} actions.payload - Payload containing new cart items
     * @param {Object[]} actions.payload.items - Array of new cart items
     * @returns {void}
     */
    setStoreCartItems: function (state, actions) {
      const { items } = actions.payload;
      state.cartDetails.items = !items?.length ? [] : items;
      state.cartDetails.subTotal = calculateSubtotal(state.cartDetails.items);
    },

    setCartSynced: function (state, actions) {
      state.cartDetails.isCartSynced = actions.payload;
    },
    setCartInputValue:function (state, actions) {
      state.cartInputValue = actions.payload;
    },
  },
});

export const {
  setStoreCartItems,
  updateStoreCartItem,
  addStoreCartItem,
  setCartSynced,
  setCartInputValue
} = cartSlice.actions;
export default cartSlice.reducer;
